import PropTypes from 'prop-types';

import Price from './Price';

const Surcharge = {
  total: PropTypes.shape(Price),
  surchargeCode: PropTypes.string,
  description: PropTypes.string,
  count: PropTypes.shape({
    adults: PropTypes.number,
    children: PropTypes.number,
  }),
};

const Charges = {
  total: PropTypes.shape(Price),
  perTraveller: PropTypes.shape(Price),
  breakdown: PropTypes.shape({
    surcharges: PropTypes.arrayOf(PropTypes.shape(Surcharge)),
  }),
  packageTotal: PropTypes.shape(Price),
};

export default Charges;
